"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DESCRIPTION = void 0;
const DESCRIPTION = exports.DESCRIPTION = 'description';
